import React, {
    useMemo,
} from 'react'
import moment from 'moment'
import {
    GridFilterInputValueProps,
} from '@mui/x-data-grid-pro'
import noop from 'lodash/noop'

import {
    dateMask,
    dateToStr,
} from 'app/utils/date'
import DateRangeSelector from 'app/shared-components/DateRangeSelector'

import useStyles from './TimeLessDateRangeSelectorFilterInput.styles'

type DateRangeFilterType<T> = {
    from: T,
    to: T,
}

type FilterTypeForFilterModel = DateRangeFilterType<string | undefined>
type FilterTypeForSelector = DateRangeFilterType<number | undefined>

const parseToFromValueToFilterModelFormat = (
    value: FilterTypeForSelector,
): FilterTypeForFilterModel => {
    return {
        from: value.from ? dateToStr(value.from, dateMask) : undefined,
        to: value.to ? dateToStr(value.to, dateMask) : undefined,
    }
}

const parseFilterModelToToFromValue = (filter: FilterTypeForFilterModel): FilterTypeForSelector => {
    return {
        from: filter?.from ? moment(filter?.from, dateMask).valueOf() : null,
        to: filter?.to ? moment(filter?.to, dateMask).valueOf() : null,
    }
}

function TimeLessDateRangeSelectorFilterInput({
    item,
    applyValue,
}: Readonly<GridFilterInputValueProps>) {
    const {
        classes,
    } = useStyles()
    const localOnChange = (newValue): void => {
        applyValue({
            ...item,
            value: parseToFromValueToFilterModelFormat(newValue),
        })
    }

    const value = useMemo(() => {
        return parseFilterModelToToFromValue(item.value) as FilterTypeForSelector
    }, [item.value])

    return (
        <div className={classes.wrapper}>
            <DateRangeSelector
                mini
                showTimeRange
                setDateRange={noop}
                onChange={localOnChange}
                value={value}
            />
        </div>
    )
}

export default TimeLessDateRangeSelectorFilterInput
